import { userState } from '../states/userState';
import { setCookie, getCookie, deleteCookie } from '../utils';
import { useRecoilState } from 'recoil';

const ONE_WEEK = 24 * 60 * 60 * 7;
const REMEMBER_ME_LOCAL_STORAGE_KEY = 'remember-me';
const REFRESH_TOKEN_COOKIE_KEY = 'refreshToken';
const defaultCookieOption = {}; // @TODO: {httpOnly: true, secure: true} 옵션 적용하기

// @TODO: 일렉트론에서는 쿠키가 아닌 localStorage 사용해야함
// 로그인, accessToken과 refreshToken 관리 등 인증과 관련된 역할을 분리한 hook
const useAuth = () => {
  const [userInfo, setUserState] = useRecoilState(userState);
  const getIsRemember = () =>
    localStorage.getItem(REMEMBER_ME_LOCAL_STORAGE_KEY) === 'true';

  const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_COOKIE_KEY);
  const setRefreshToken = (refreshToken: string) => {
    const isRemember = getIsRemember();

    localStorage.setItem(REFRESH_TOKEN_COOKIE_KEY, refreshToken);
  };

  const getAccessToken = () => userInfo.accessToken;
  const setAccessToken = (accessToken: string) =>
    setUserState((prev) => ({ ...prev, accessToken }));

  const setIsRemember = (isRemember: boolean) =>
    localStorage.setItem(REMEMBER_ME_LOCAL_STORAGE_KEY, `${isRemember}`);

  const logOut = () => {
    localStorage.removeItem(REFRESH_TOKEN_COOKIE_KEY);
    setUserState({
      userInfo: null,
      accessToken: '',
    });
  };

  return {
    getRefreshToken,
    setRefreshToken,
    getAccessToken,
    setAccessToken,
    setIsRemember,
    getIsRemember,
    logOut,
  };
};

export default useAuth;
